// Fonte: Secretaria Estadual de Saúde de SP — COSEMSSP
// 212 PESAs (Pontos Estratégicos de Soro Antiveneno)
// Atualizado em 16/06/2023
// https://www.cosemssp.org.br/wp-content/uploads/2023/06/LISTAGEM-SORO-ANIMAIS-PECONHENTOS.pdf

export interface Hospital {
  id: number;
  nome: string;
  endereco: string;
  cidade: string;
  regiao: string;
  telefone: string;
  soros: string[];
  lat: number;
  lng: number;
  municipiosAtendidos?: string;
}

export const HOSPITAIS_SP: Hospital[] = [
  // === CAPITAL — 6 PESAs ===
  {
    id: 1,
    nome: 'Hospital Vital Brazil — Instituto Butantan',
    endereco: 'Av. Vital Brasil, 1500 — Instituto Butantan',
    cidade: 'São Paulo',
    regiao: 'Zona Oeste',
    telefone: '(11) 2627-9529',
    soros: ['Escorpiônico', 'Aracnídico', 'Antiofídico', 'Lonômico'],
    lat: -23.5681, lng: -46.7166,
    municipiosAtendidos: 'Toda cidade de SP (Zonas Oeste, Centro e Norte para escorpiônico)'
  },
  {
    id: 2,
    nome: 'Hospital Geral de Taipas — Kátia de Souza Rodrigues',
    endereco: 'Av. Elísio Teixeira Leite, 6999 — Jaraguá',
    cidade: 'São Paulo',
    regiao: 'Zona Norte',
    telefone: '(11) 3973-0400',
    soros: ['Escorpiônico'],
    lat: -23.4502, lng: -46.7424,
    municipiosAtendidos: 'Zona Norte da Capital'
  },
  {
    id: 3,
    nome: 'Hospital Municipal Dr. Carmino Caricchio — Tatuapé',
    endereco: 'Av. Celso Garcia, 4815 — Tatuapé',
    cidade: 'São Paulo',
    regiao: 'Zona Leste',
    telefone: '(11) 3394-6980',
    soros: ['Escorpiônico'],
    lat: -23.5405, lng: -46.5696,
    municipiosAtendidos: 'Zonas Centro, Leste, Sudeste e Norte'
  },
  {
    id: 4,
    nome: 'Hospital Campo Limpo — PS Fernando Mauro Pires da Rocha',
    endereco: 'Rua Teresa Mouco de Oliveira, 121 — Jardim São Luiz',
    cidade: 'São Paulo',
    regiao: 'Zona Sul',
    telefone: '(11) 3394-7556',
    soros: ['Escorpiônico'],
    lat: -23.6792, lng: -46.7632,
    municipiosAtendidos: 'Zona Sul da Capital'
  },
  {
    id: 5,
    nome: 'Hospital Estadual Prof. Liberato John Alphonse Di Dio — Grajaú',
    endereco: 'R. Francisco Octavio Pacca, 180 — Parque das Nações',
    cidade: 'São Paulo',
    regiao: 'Zona Sul',
    telefone: '(11) 3544-9444',
    soros: ['Escorpiônico'],
    lat: -23.7042, lng: -46.6897,
    municipiosAtendidos: 'Zona Sul da Capital'
  },
  {
    id: 6,
    nome: 'Hospital Municipal Tide Setúbal',
    endereco: 'R. Dr. José Guilherme Eiras, 123 — São Miguel Paulista',
    cidade: 'São Paulo',
    regiao: 'Zona Leste',
    telefone: '(11) 3394-8770',
    soros: ['Escorpiônico'],
    lat: -23.4967, lng: -46.4333,
    municipiosAtendidos: 'Zona Leste da Capital'
  },
  // === GRANDE SP ===
  {
    id: 7,
    nome: 'Hospital de Urgência — São Bernardo do Campo',
    endereco: 'R. Joaquim Nabuco, 380 — Centro',
    cidade: 'São Bernardo do Campo',
    regiao: 'Grande SP / ABC',
    telefone: '(11) 2630-9827',
    soros: ['Escorpiônico', 'Aracnídico'],
    lat: -23.6939, lng: -46.5650,
    municipiosAtendidos: 'Diadema, Mauá, Santo André, SBC, São Caetano do Sul, Ribeirão Pires, Rio Grande da Serra'
  },
  {
    id: 8,
    nome: 'Hospital Municipal de Guarulhos',
    endereco: 'Av. Tiradentes, 3392 — Bom Clima',
    cidade: 'Guarulhos',
    regiao: 'Grande SP',
    telefone: '(11) 2475-7449',
    soros: ['Escorpiônico', 'Aracnídico', 'Antiofídico'],
    lat: -23.4543, lng: -46.5332,
    municipiosAtendidos: 'Guarulhos e Arujá'
  },
  {
    id: 9,
    nome: 'Hospital Dr. Osíris Florindo Coelho',
    endereco: 'R. Princesa Isabel, 270 — Vila Correa',
    cidade: 'Ferraz de Vasconcelos',
    regiao: 'Grande SP',
    telefone: '(11) 4675-3444',
    soros: ['Escorpiônico'],
    lat: -23.5411, lng: -46.3681,
    municipiosAtendidos: 'Ferraz de Vasconcelos, Itaquaquecetuba, Poá, Suzano'
  },
  {
    id: 10,
    nome: 'Hospital Regional de Cotia',
    endereco: 'Av. Odair Pacheco Pedroso, 171',
    cidade: 'Cotia',
    regiao: 'Grande SP / Osasco',
    telefone: '(11) 4148-2222',
    soros: ['Escorpiônico', 'Aracnídico', 'Antiofídico'],
    lat: -23.6029, lng: -46.9202,
    municipiosAtendidos: 'Cotia e Vargem Grande Paulista'
  },
  {
    id: 11,
    nome: 'Hospital Geral de Itapevi',
    endereco: 'Rua Jesuino Joaquim da Silva, s/n — Jardim Nova Itapevi',
    cidade: 'Itapevi',
    regiao: 'Grande SP / Osasco',
    telefone: '(11) 4143-8600',
    soros: ['Escorpiônico'],
    lat: -23.5479, lng: -46.9357,
    municipiosAtendidos: 'Itapevi e Pirapora do Bom Jesus'
  },
  {
    id: 12,
    nome: 'Hospital e Maternidade de Mairiporã',
    endereco: 'Rua Ipiranga, 280 — Centro',
    cidade: 'Mairiporã',
    regiao: 'Grande SP / Franco da Rocha',
    telefone: '(11) 4419-4422',
    soros: ['Escorpiônico'],
    lat: -23.3175, lng: -46.5868,
    municipiosAtendidos: 'Mairiporã'
  },
  {
    id: 13,
    nome: 'Pronto Socorro Municipal — Embu das Artes',
    endereco: 'Av. Elias Yasbeck, 1415 — Centro',
    cidade: 'Embu das Artes',
    regiao: 'Grande SP',
    telefone: '(11) 4785-0151',
    soros: ['Escorpiônico', 'Antiofídico'],
    lat: -23.6504, lng: -46.8527,
    municipiosAtendidos: 'Embu das Artes e Taboão da Serra'
  },
  {
    id: 14,
    nome: 'Pronto Socorro Central — Itapecerica da Serra',
    endereco: 'R. Carlos Eduardo D. Tautico, 77',
    cidade: 'Itapecerica da Serra',
    regiao: 'Grande SP',
    telefone: '(11) 4668-6803',
    soros: ['Escorpiônico', 'Aracnídico', 'Antiofídico'],
    lat: -23.7166, lng: -46.8499,
    municipiosAtendidos: 'Itapecerica da Serra'
  },
  // === CAMPINAS ===
  {
    id: 15,
    nome: 'Hospital das Clínicas da UNICAMP — CCI',
    endereco: 'Barão Geraldo — Campinas',
    cidade: 'Campinas',
    regiao: 'Campinas',
    telefone: '(19) 3521-6700',
    soros: ['Escorpiônico', 'Aracnídico', 'Antiofídico', 'Lonômico'],
    lat: -22.8302, lng: -47.0653,
    municipiosAtendidos: 'Referência para toda região de Campinas'
  },
  {
    id: 16,
    nome: 'Complexo Hospitalar Pref. Edivaldo Orsi',
    endereco: 'Av. Ruy Rodrigues, 3434 — Chapadão',
    cidade: 'Campinas',
    regiao: 'Campinas',
    telefone: '(19) 3772-8347',
    soros: ['Escorpiônico'],
    lat: -22.8690, lng: -47.0444,
    municipiosAtendidos: 'Campinas — Distrito Noroeste e Sudeste'
  },
  {
    id: 17,
    nome: 'Hospital Municipal Waldemar Tebaldi',
    endereco: 'Av. da Saúde, 415 — Jardim N. Sra. Fátima',
    cidade: 'Americana',
    regiao: 'Campinas',
    telefone: '(19) 3471-6750',
    soros: ['Escorpiônico', 'Aracnídico'],
    lat: -22.7386, lng: -47.3358,
    municipiosAtendidos: 'Americana, Cosmópolis, Nova Odessa'
  },
  {
    id: 18,
    nome: 'Hospital Estadual Dr. Leandro Franceschini',
    endereco: 'Av. da Amizade, 2400 — Jardim Bela Vista',
    cidade: 'Sumaré',
    regiao: 'Campinas',
    telefone: '(19) 3883-8899',
    soros: ['Escorpiônico', 'Aracnídico'],
    lat: -22.8218, lng: -47.2659,
    municipiosAtendidos: 'Sumaré e Hortolândia'
  },
  {
    id: 19,
    nome: 'Hospital Augusto de Oliveira Camargo',
    endereco: 'Av. Francisco de Paula Leite, 399',
    cidade: 'Indaiatuba',
    regiao: 'Campinas',
    telefone: '(19) 3801-8200',
    soros: ['Escorpiônico', 'Aracnídico'],
    lat: -23.0917, lng: -47.2183,
    municipiosAtendidos: 'Indaiatuba e Monte Mor'
  },
  {
    id: 20,
    nome: 'Pronto Socorro Édson Mano',
    endereco: 'Rua Alice Aranha de Oliveira, 45 — Vila Maria',
    cidade: 'Santa Bárbara D\'Oeste',
    regiao: 'Campinas',
    telefone: '(19) 3464-9210',
    soros: ['Escorpiônico', 'Aracnídico'],
    lat: -22.7534, lng: -47.4142,
    municipiosAtendidos: 'Santa Bárbara D\'Oeste'
  },
  // === RIBEIRÃO PRETO ===
  {
    id: 21,
    nome: 'Hospital das Clínicas — FMRP/USP',
    endereco: 'Rua Bernardino de Campos, 1000 — Centro',
    cidade: 'Ribeirão Preto',
    regiao: 'Ribeirão Preto',
    telefone: '(16) 3602-1190',
    soros: ['Escorpiônico', 'Aracnídico', 'Antiofídico', 'Lonômico'],
    lat: -21.1704, lng: -47.8103,
    municipiosAtendidos: 'Referência para toda região de Ribeirão Preto'
  },
  // === SÃO JOSÉ DO RIO PRETO ===
  {
    id: 22,
    nome: 'Hospital de Base de São José do Rio Preto',
    endereco: 'Av. Brigadeiro Faria Lima, 5544',
    cidade: 'São José do Rio Preto',
    regiao: 'São José do Rio Preto',
    telefone: '(17) 3201-5000',
    soros: ['Escorpiônico', 'Aracnídico', 'Antiofídico'],
    lat: -20.8256, lng: -49.3749,
    municipiosAtendidos: 'Referência para toda região de SJRP'
  },
  // === SOROCABA ===
  {
    id: 23,
    nome: 'Pronto Socorro — Conjunto Hospitalar de Sorocaba',
    endereco: 'Rua Cláudio Manoel da Costa, s/n',
    cidade: 'Sorocaba',
    regiao: 'Sorocaba',
    telefone: '(15) 3332-9125',
    soros: ['Escorpiônico', 'Aracnídico', 'Antiofídico', 'Lonômico'],
    lat: -23.4889, lng: -47.4308,
    municipiosAtendidos: 'Sorocaba, Alumínio, Araçariguama, Mairinque, Salto de Pirapora, São Roque, Porto Feliz, Votorantim'
  },
  // === BAIXADA SANTISTA — 8 PESAs ===
  {
    id: 24,
    nome: 'Hospital Guilherme Álvaro',
    endereco: 'R. Oswaldo Cruz, 197',
    cidade: 'Santos',
    regiao: 'Baixada Santista',
    telefone: '(13) 3202-1300',
    soros: ['Escorpiônico', 'Aracnídico', 'Antiofídico'],
    lat: -23.9442, lng: -46.3329,
    municipiosAtendidos: 'Santos e São Vicente'
  },
  {
    id: 241,
    nome: 'Hospital Municipal de Bertioga',
    endereco: 'Pça. Vicente Molinari, s/n',
    cidade: 'Bertioga',
    regiao: 'Baixada Santista',
    telefone: '(13) 3319-9900',
    soros: ['Escorpiônico', 'Aracnídico', 'Antiofídico'],
    lat: -23.8533, lng: -46.1386,
    municipiosAtendidos: 'Bertioga'
  },
  {
    id: 242,
    nome: 'PS Central Guiomar Ferreira Roebbelen',
    endereco: 'Av. 9 de Abril, s/n',
    cidade: 'Cubatão',
    regiao: 'Baixada Santista',
    telefone: '(13) 3361-8786',
    soros: ['Escorpiônico', 'Aracnídico', 'Antiofídico'],
    lat: -23.8936, lng: -46.4258,
    municipiosAtendidos: 'Cubatão'
  },
  {
    id: 243,
    nome: 'Hospital Santo Amaro',
    endereco: 'R. Quinto Bertoldi, 40 — Vila Maia',
    cidade: 'Guarujá',
    regiao: 'Baixada Santista',
    telefone: '(13) 3389-1515',
    soros: ['Escorpiônico', 'Aracnídico', 'Antiofídico'],
    lat: -23.9929, lng: -46.2564,
    municipiosAtendidos: 'Guarujá'
  },
  {
    id: 244,
    nome: 'UPA Itanhaém',
    endereco: 'R. José Ernesto Bechelli, s/n — Jardim Sabaúna',
    cidade: 'Itanhaém',
    regiao: 'Baixada Santista',
    telefone: '(13) 3427-1111',
    soros: ['Escorpiônico', 'Aracnídico', 'Antiofídico'],
    lat: -24.1831, lng: -46.7894,
    municipiosAtendidos: 'Itanhaém'
  },
  {
    id: 245,
    nome: 'UPA Mongaguá',
    endereco: 'Av. Monteiro Lobato, 9400 — Agenor de Campos',
    cidade: 'Mongaguá',
    regiao: 'Baixada Santista',
    telefone: '(13) 3507-1110',
    soros: ['Escorpiônico', 'Aracnídico', 'Antiofídico'],
    lat: -24.0858, lng: -46.6269,
    municipiosAtendidos: 'Mongaguá'
  },
  {
    id: 246,
    nome: 'UPA Peruíbe',
    endereco: 'Av. Prof. Terezinha Rodrigues Kalil, s/n — Pq. Davilli',
    cidade: 'Peruíbe',
    regiao: 'Baixada Santista',
    telefone: '(13) 3454-1589',
    soros: ['Escorpiônico', 'Aracnídico', 'Antiofídico'],
    lat: -24.3194, lng: -46.9986,
    municipiosAtendidos: 'Peruíbe'
  },
  {
    id: 247,
    nome: 'PS Hospital Irmã Dulce',
    endereco: 'Av. São Paulo, 1014',
    cidade: 'Praia Grande',
    regiao: 'Baixada Santista',
    telefone: '(13) 3476-4435',
    soros: ['Escorpiônico', 'Aracnídico', 'Antiofídico'],
    lat: -24.0059, lng: -46.4028,
    municipiosAtendidos: 'Praia Grande'
  },
  // === SÃO JOSÉ DOS CAMPOS ===
  {
    id: 25,
    nome: 'Hospital Municipal Dr. José de Carvalho Florence',
    endereco: 'Rua Saigiro Nakamura, 800 — Vila Industrial',
    cidade: 'São José dos Campos',
    regiao: 'Vale do Paraíba',
    telefone: '(12) 3901-3400',
    soros: ['Escorpiônico', 'Aracnídico', 'Antiofídico'],
    lat: -23.1791, lng: -45.8869,
    municipiosAtendidos: 'São José dos Campos e região'
  },
  // === BAURU ===
  {
    id: 26,
    nome: 'Pronto Socorro Municipal Central — Bauru',
    endereco: 'Rua Rubens Arruda, Qd. 07, s/n',
    cidade: 'Bauru',
    regiao: 'Bauru',
    telefone: '(14) 3104-1160',
    soros: ['Escorpiônico', 'Aracnídico', 'Antiofídico'],
    lat: -22.3154, lng: -49.0608,
    municipiosAtendidos: 'Bauru, Agudos, Arealva, Avaí, Pederneiras, Piratininga e região'
  },
  // === PIRACICABA ===
  {
    id: 27,
    nome: 'Santa Casa de Misericórdia de Piracicaba',
    endereco: 'Av. Independência, 953',
    cidade: 'Piracicaba',
    regiao: 'Piracicaba',
    telefone: '(19) 3417-5000',
    soros: ['Escorpiônico', 'Aracnídico', 'Antiofídico'],
    lat: -22.7253, lng: -47.6476,
    municipiosAtendidos: 'Piracicaba e região norte/sul/leste'
  },
  // === ARAÇATUBA ===
  {
    id: 28,
    nome: 'Santa Casa de Misericórdia de Araçatuba',
    endereco: 'Rua Floriano Peixoto, 896 — Vila Mendonça',
    cidade: 'Araçatuba',
    regiao: 'Araçatuba',
    telefone: '(18) 3607-3000',
    soros: ['Escorpiônico', 'Aracnídico', 'Antiofídico'],
    lat: -21.2094, lng: -50.4329,
    municipiosAtendidos: 'Araçatuba e toda região do GVE Araçatuba'
  },
  // === PRESIDENTE PRUDENTE ===
  {
    id: 29,
    nome: 'Hospital Universitário — Regional de Presidente Prudente',
    endereco: 'Rua José Bogiovani, 900',
    cidade: 'Presidente Prudente',
    regiao: 'Presidente Prudente',
    telefone: '(18) 3229-1500',
    soros: ['Escorpiônico', 'Aracnídico', 'Antiofídico'],
    lat: -22.1200, lng: -51.3870,
    municipiosAtendidos: 'Presidente Prudente e toda região do GVE'
  },
  // === FRANCA ===
  {
    id: 30,
    nome: 'Santa Casa de Misericórdia de Franca',
    endereco: 'Pça. D. Pedro I, 1826',
    cidade: 'Franca',
    regiao: 'Franca',
    telefone: '(16) 3711-4000',
    soros: ['Escorpiônico', 'Aracnídico', 'Antiofídico'],
    lat: -20.5411, lng: -47.3997,
    municipiosAtendidos: 'Franca, Restinga, Ribeirão Corrente, Cristais Paulista, São José da Bela Vista'
  },
  // === BOTUCATU ===
  {
    id: 31,
    nome: 'Hospital das Clínicas de Botucatu — UNESP',
    endereco: 'Distrito de Rubião Junior, s/n',
    cidade: 'Botucatu',
    regiao: 'Botucatu',
    telefone: '(14) 3811-6129',
    soros: ['Escorpiônico', 'Aracnídico', 'Antiofídico', 'Lonômico'],
    lat: -22.8823, lng: -48.4453,
    municipiosAtendidos: 'Referência para toda região de Botucatu'
  },
  // === ARARAQUARA ===
  {
    id: 32,
    nome: 'UPA Central Amélia Bernardino Cutrale',
    endereco: 'Av. Maria Antonia Camargo de Oliveira, 3821 — Vila Ferroviária',
    cidade: 'Araraquara',
    regiao: 'Araraquara',
    telefone: '(16) 3334-6900',
    soros: ['Escorpiônico', 'Aracnídico', 'Antiofídico', 'Lonômico'],
    lat: -21.7938, lng: -48.1758,
    municipiosAtendidos: 'Araraquara, Américo Brasiliense, Boa Esperança do Sul, Gavião Peixoto, Motuca, Rincão, Santa Lúcia, Trabiju'
  },
  // === TAUBATÉ ===
  {
    id: 33,
    nome: 'Pronto Socorro Municipal de Taubaté',
    endereco: 'Rua Benedito Cursino dos Santos, 101 — Centro',
    cidade: 'Taubaté',
    regiao: 'Vale do Paraíba',
    telefone: '(12) 3621-6036',
    soros: ['Escorpiônico', 'Aracnídico', 'Antiofídico'],
    lat: -23.0268, lng: -45.5556,
    municipiosAtendidos: 'Taubaté, Tremembé, Redenção da Serra, Natividade da Serra e região'
  },
];

// Calcula distância em km entre dois pontos (fórmula de Haversine)
export function calcularDistancia(lat1: number, lng1: number, lat2: number, lng2: number): number {
  const R = 6371;
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLng = (lng2 - lng1) * Math.PI / 180;
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
    Math.sin(dLng / 2) * Math.sin(dLng / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
}

// Retorna hospitais ordenados por distância a partir de coordenadas
export function hospitaisMaisProximos(lat: number, lng: number, limite = 5): (Hospital & { distanciaKm: number })[] {
  return HOSPITAIS_SP
    .map(h => ({ ...h, distanciaKm: calcularDistancia(lat, lng, h.lat, h.lng) }))
    .sort((a, b) => a.distanciaKm - b.distanciaKm)
    .slice(0, limite);
}
